import eventYogaImage from '@/assets/tour-demo/event-yoga.jpg';
import buddyAvatarImage from '@/assets/tour-demo/buddy-avatar.jpg';

export const demoEvent = {
  id: 'demo-event',
  title: 'Sunrise Yoga at the Pearl',
  category: 'Movement',
  host_name: 'Wellness Cowgirl',
  date: 'Saturday, Dec 14th • 8:00 AM',
  location: 'The Pearl, San Antonio',
  image: eventYogaImage,
  duration: '60 min',
  attendees: 12,
};

export const demoBuddy = {
  id: 'demo-buddy',
  name: 'Sarah M.',
  avatar: buddyAvatarImage,
  message: "Hey! I'm new to yoga and a bit nervous going alone. Would love a buddy! 🧘‍♀️",
};

export const demoMessages = [
  {
    id: '1',
    sender: 'buddy',
    content: "Hey! So excited we matched for yoga! 🎉",
    time: '8:32 AM',
  },
  {
    id: '2',
    sender: 'user',
    content: "Me too! Want to meet at the coffee shop beforehand?",
    time: '8:33 AM',
  },
  {
    id: '3',
    sender: 'buddy',
    content: "Perfect! See you at 7:30? ☕",
    time: '8:34 AM',
  },
];
